import { useCallback } from "react";
import { UserMenu } from "@iq/models";
import { CiLogout } from "react-icons/ci";
import { FaChevronDown } from "react-icons/fa";
import { MdOutlineSecurity } from "react-icons/md";
import IQLogo from "../assets/icons/IQ_small_logo.svg";
import SecurityQuestionSetup from "../CRM/components/modals/SecurityQuestionSetup";
import { logout } from "../services/authApi";
import useAuthStore from "../states/authStore";

export default function AppUserMenu({ name, id }) {
	const profile = useAuthStore((state) => state.profile);
	const clearAuth = useAuthStore((state) => state.clearAuth);

	const resolvedName = name || profile?.name || "User";
	const resolvedId = id ?? profile?.id ?? null;

	const handleLogout = useCallback(async () => {
		try {
			await logout();
		} catch {
			// Clear client auth state even if the logout request fails.
		} finally {
			clearAuth();
			window.location.assign("/login");
		}
	}, [clearAuth]);

	const renderSecurityQuestionModal = useCallback(
		({ profileId, displayName, close }) => (
			<SecurityQuestionSetup
				profile={{
					id: profileId ?? resolvedId,
					name: displayName || resolvedName,
				}}
				onComplete={close}
				onBack={close}
			/>
		),
		[resolvedId, resolvedName]
	);

	return (
		<UserMenu
			name={resolvedName}
			id={resolvedId}
			logoSrc={IQLogo}
			logoAlt="IQ logo"
			chevronIcon={<FaChevronDown size={12} />}
			securityActionIcon={<MdOutlineSecurity size={16} strokeWidth={0.4} />}
			logoutActionIcon={<CiLogout size={18} strokeWidth={1.2} />}
			onLogout={handleLogout}
			canUpdateSecurityQuestion={Boolean(resolvedId)}
			renderSecurityQuestionModal={renderSecurityQuestionModal}
		/>
	);
}
